import { ChevronLeft, ChevronRight } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';
import { Button, Icon } from 'vet-bones/design-system/components';

import styles from 'src/components/resourceDialog/styles/panelWithSidebar.module.scss';

export type PanelWithSidebarProps = {
  asideHeader?: React.ReactNode;
  asideContent: React.ReactNode;
  asideFooter?: React.ReactNode;
  mainContent: React.ReactNode;
  initialAsideOpen?: boolean;
};

export const PanelWithSidebar: React.VFC<PanelWithSidebarProps> = ({
  asideHeader,
  asideContent,
  asideFooter,
  mainContent,
  initialAsideOpen = true,
}) => {
  const [isAsideOpen, setIsAsideOpen] = React.useState(initialAsideOpen);

  return (
    <div
      className={classNames(styles.panelWithSidebar, {
        [styles.asideOpen]: isAsideOpen,
        [styles.asideClosed]: !isAsideOpen,
      })}
    >
      <div className={styles.aside}>
        <div className={styles.expand}>
          <Button
            className={styles.expandButton}
            onClick={() => setIsAsideOpen((prev) => !prev)}
            size="xs"
            variant="tertiary-gray"
          >
            <Icon
              IconComponent={isAsideOpen ? ChevronLeft : ChevronRight}
              size="sm"
            />
          </Button>
        </div>
        <div className={styles.asideContent}>
          {asideHeader ? (
            <div className={styles.asideContentHeader}>{asideHeader}</div>
          ) : null}
          <div className={styles.asideContentScrollable}>{asideContent}</div>
        </div>
        {asideFooter ? (
          <div className={styles.asideFooter}>{asideFooter}</div>
        ) : null}
      </div>
      <div className={styles.main}>
        <div className={styles.preview}>{mainContent}</div>
      </div>
    </div>
  );
};
